<template>
  <layouts>
    <template #content>
      <zloading v-if="loading"></zloading>
      <div v-else class="bg-gray-200 h-full">
        <notification
          v-show="successNotification"
          :message="successMessage"
          @close="successNotification = false"
        ></notification>
        <div class="container px-4 py-10 mx-auto max-w-7xl">
          <div class="flex items-start justify-between mb-6">
            <div>
              <div class="flex items-center">
                <button
                  @click="startScanBarcode"
                  class="bg-green-600 hover:bg-green-700 rounded-md px-3 py-2 text-sm text-white focus:outline-none flex items-center transition duration-300 ease-in"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-3.5 h-3.5 mr-2 fill-current"
                    viewBox="0 0 24 24"
                    style="transform:;-ms-filter:"
                  >
                    <path
                      d="M3 4v5h2V5h4V3H4C3.447 3 3 3.447 3 4zM21 9V4c0-.553-.447-1-1-1h-5v2h4v4H21zM19 19h-4v2h5c.553 0 1-.447 1-1v-5h-2V19zM9 21v-2H5v-4H3v5c0 .553.447 1 1 1H9zM2 11H22V13H2z"
                    ></path>
                  </svg>
                  <h4 class="font-semibold -mt-0.5">Scan Barcode</h4>
                </button>
              </div>
              <h4 class="font-semibold mt-4">
                Jumlah Item: {{ data.data == undefined ? 0 : data.data.length }}
              </h4>
            </div>
            <div>
              <div class="flex items-center justify-end mb-2">
                <form class="relative mr-2">
                  <svg
                    width="15"
                    height="15"
                    fill="currentColor"
                    class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    />
                  </svg>
                  <input
                    v-model="search_no_order"
                    @input="refreshData"
                    class="focus:outline-none w-full text-sm text-black placeholder-gray-500 border border-gray-300 rounded-md py-2 pl-10"
                    type="text"
                    aria-label="Pencarian.."
                    placeholder="Cari No Order.."
                  />
                </form>
                <form class="relative mr-2">
                  <svg
                    width="15"
                    height="15"
                    fill="currentColor"
                    class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    />
                  </svg>
                  <input
                    v-model="search_awb_no"
                    @input="refreshData"
                    class="focus:outline-none w-full text-sm text-black placeholder-gray-500 border border-gray-300 rounded-md py-2 pl-10"
                    type="text"
                    aria-label="Pencarian.."
                    placeholder="Cari Resi.."
                  />
                </form>
                <form class="relative mr-2">
                  <svg
                    width="15"
                    height="15"
                    fill="currentColor"
                    class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    />
                  </svg>
                  <input
                    v-model="search_recipient_name"
                    @input="refreshData"
                    class="focus:outline-none w-full text-sm text-black placeholder-gray-500 border border-gray-300 rounded-md py-2 pl-10"
                    type="text"
                    aria-label="Pencarian.."
                    placeholder="Cari Nama Penerima.."
                  />
                </form>
              </div>
              <div class="lg:flex lg:items-center lg:mb-0 mb-2 justify-end">
                <zselect
                  v-model="limit"
                  :data="[5, 10, 25, 50, 80, 100, 200, 300, 500]"
                  placeholder="Jumlah"
                  @input="refreshData"
                  class="-mt-1 mr-2"
                  style="width: 80px"
                >
                </zselect>
                <zdropdown
                  :text="filterDate !== '' ? filterDate : 'Filter Transaksi'"
                  class="lg:mr-2"
                >
                  <template v-slot:item>
                    <div class="py-6 px-6">
                      <h4 class="text-sm font-medium mr-2 mb-1">
                        Rentang Tanggal:
                      </h4>
                      <zselect
                        class="mb-5"
                        v-model="filterDate"
                        :data="[
                          'Hari Ini',
                          'Bulan Ini',
                          'Tahun Ini',
                          '7 Hari Terakhir',
                          '30 Hari Terakhir',
                        ]"
                        placeholder="Pilih Periode"
                        @input="selectRangeDate"
                      >
                      </zselect>
                      <h1 class="font-medium mb-5">atau</h1>
                      <div class="flex items-center space-x-2">
                        <div class="w-1/2">
                          <h4 class="text-sm font-medium mr-2 mb-1">
                            Tanggal Mulai:
                          </h4>
                          <input
                            v-model="start_date"
                            class="w-full mr-5 rounded-md border-2 border-gray-300 focus:outline-none focus:border-blue-800 text-sm px-3 py-1.5"
                            type="date"
                          />
                        </div>
                        <div class="w-1/2">
                          <h4 class="text-sm font-medium mr-2 mb-1">
                            Tanggal Akhir:
                          </h4>
                          <input
                            v-model="end_date"
                            class="w-full rounded-md border-2 border-gray-300 focus:outline-none focus:border-blue-800 text-sm px-3 py-1.5"
                            type="date"
                          />
                        </div>
                      </div>
                      <h4 class="text-sm font-medium mr-2 mb-1 mt-2">Mitra:</h4>
                      <!-- <zselect v-model="filter_courier" :data="courierOptions" placeholder="Pilih Mitra Ekspedisi" @input="filterCourier">
                                        </zselect> -->
                      <zselectmultiple
                        v-model="filter_courier"
                        :data="courierOptions"
                        placeholder="Pilih Mitra Ekspedisi"
                        ref="filterCourierComponent"
                      >
                      </zselectmultiple>
                      <h4 class="text-sm font-medium mr-2 mb-1 mt-2">
                        Negara Tujuan:
                      </h4>
                      <!-- <zautocomplete v-model="filter_destination" :data="countryDestinationOptions" placeholder="Pilih Negara Tujuan" @input="filterDestination">
                                        </zautocomplete> -->
                      <zselectmultiple
                        v-model="filter_destination"
                        :data="countryDestinationOptions"
                        placeholder="Pilih Negara Tujuan"
                        ref="filterDestinationComponent"
                      >
                      </zselectmultiple>
                      <h4 class="text-sm font-medium mr-2 mb-1 mt-2">
                        Status:
                      </h4>
                      <zselect
                        v-model="filter_status_order"
                        :data="[
                          'Belum Ada Status',
                          'Hold',
                          'Cancel',
                          'Manifest',
                          'Pending',
                        ]"
                        placeholder="Pilih Status Order"
                      >
                      </zselect>
                      <div>
                        <h4 class="text-sm font-medium mt-2 mb-1">
                          Tanggal Manifest:
                        </h4>
                        <input
                          v-model="filter_manifest_date"
                          class="w-full mr-5 rounded-md border-2 border-gray-300 focus:outline-none focus:border-blue-800 text-sm px-3 py-1.5"
                          type="date"
                        />
                      </div>
                      <h4 class="text-sm font-medium mt-2 mb-1">Agen:</h4>
                      <zautocompleteinput
                        v-model="filter_agen"
                        :data="agenOptions"
                        placeholder="Pilih Agen"
                      >
                      </zautocompleteinput>
                      <h4 class="text-sm font-medium mt-2 mb-1">Admin:</h4>
                      <zautocompleteinput
                        v-model="filter_admin"
                        :data="adminOptions"
                        placeholder="Pilih Admin"
                      >
                      </zautocompleteinput>
                      <h4 class="text-sm font-medium mt-2 mb-1">
                        Tipe Pembayaran:
                      </h4>
                      <zselect
                        v-model="filter_payment_method"
                        :data="['Cash', 'Transfer', 'Credit']"
                        placeholder="Pilih Tipe Pembayaran"
                      >
                      </zselect>
                      <h4 class="text-sm font-medium mt-2 mb-1">Cabang:</h4>
                      <zselectmultiple
                        v-model="filter_branch"
                        :data="branchOptions"
                        placeholder="Pilih Cabang"
                        ref="filterBranchComponent"
                      >
                      </zselectmultiple>
                      <div class="flex items-center mt-5 space-x-2">
                        <button
                          @click="resetData"
                          class="bg-gray-600 hover:bg-gray-700 px-4 py-2 text-sm text-semibold text-white rounded-md shadow"
                        >
                          Reset Filter
                        </button>
                        <button
                          @click="applyFiltersClick"
                          class="bg-blue-600 hover:bg-blue-700 px-4 py-2 text-sm text-semibold text-white rounded-md shadow"
                        >
                          Terapkan
                        </button>
                      </div>
                    </div>
                  </template>
                </zdropdown>
              </div>
              <div class="flex items-center">
                <h4
                  v-if="data && viewOptions == 'List'"
                  class="mr-4 text-sm mt-3"
                >
                  Total Ongkir:
                  <b>{{
                    "Rp" +
                      formatPrice(
                        data.reduce(
                          (total, num) =>
                            num.shipment_fee
                              ? total + parseInt(num.shipment_fee)
                              : total + 0,
                          0,
                        ),
                      )
                  }}</b>
                </h4>
                <h4 v-if="data && viewOptions == 'List'" class="text-sm mt-3">
                  Total Bayar ke Jaskipin:
                  <b>{{
                    "Rp" +
                      formatPrice(
                        data.reduce(
                          (total, num) =>
                            num.amount_paid
                              ? total + parseInt(num.amount_paid)
                              : total + 0,
                          0,
                        ),
                      )
                  }}</b>
                </h4>
              </div>
            </div>
          </div>
          <datatable
            :data="data.data"
            :columns="columns"
            :meta="data.meta"
            :PageNavHandler="pageNavHandler"
            :TableInputSearchHandler="tableInputSearchHandler"
          >
            <!-- Custom Field -->
            <template slot="status_order" slot-scope="props">
              <span
                v-if="props.item.status_order === 'Hold'"
                class="bg-blue-400 px-2 py-1 text-white rounded font-semibold text-xs ml-2"
                >{{ props.item.status_order }}</span
              >
              <span
                v-else-if="props.item.status_order === 'Cancel'"
                class="bg-red-400 px-2 py-1 text-white rounded font-semibold text-xs ml-2"
                >{{ props.item.status_order }}</span
              >
              <span
                v-else-if="props.item.status_order === 'Pending'"
                class="bg-yellow-400 px-2 py-1 text-white rounded font-semibold text-xs ml-2"
                >{{ props.item.status_order }}</span
              >
              <span
                v-else-if="props.item.status_order === 'Manifest'"
                class="bg-green-400 px-2 py-1 text-white rounded font-semibold text-xs ml-2"
                >{{ props.item.status_order }}</span
              >
            </template>
            <template slot="agen" slot-scope="props">
              {{
                props.item.agen
                  ? props.item.agen.fullname
                  : props.item.agen_general
              }}
            </template>
            <template slot="admin" slot-scope="props">
              {{ props.item.input_by ? props.item.input_by.fullname : "-" }}
            </template>
            <template slot="branch" slot-scope="props">
              {{ props.item.branch ? props.item.branch.city_name : "-" }}
            </template>
            <template slot="manifest_date" slot-scope="props">
              {{ formatDate(props.item.manifest_date) }}
            </template>
            <template slot="createdAt" slot-scope="props">
              {{ formatDate(props.item.createdAt) }}
            </template>
            <!-- / End Custom Field -->
          </datatable>
        </div>
        <!-- Scan Barcode -->
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="opacity-100 translate-y-0 sm:scale-100"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <detailModal
            v-show="scanBarcodeDialog"
            title="Scan Barcode"
            @close="scanBarcodeDialog = false"
          >
            <div class="p-6">
              <center>
                <input
                  v-model="code_barcode"
                  class="w-full max-w-sm rounded-md border-2 border-gray-300 focus:outline-none focus:border-blue-800 text-sm px-3 py-2"
                  ref="barcode_scanner"
                  type="text"
                  @input="onDetectBarcode"
                />
              </center>
            </div>
          </detailModal>
        </transition>
      </div>
    </template>
  </layouts>
</template>

<script>
import layouts from "@/components/layouts";
import datatable from "@/components/datatables/advance_table";
import zdropdown from "@/components/zdropdown";
import zselect from "@/components/zselect";
import zselectmultiple from "@/components/zselectmultiple";
import zautocompleteinput from "@/components/zautocompleteinput";
import zloading from "@/components/zloading";
import notification from "@/components/datatables/notification";
import detailModal from "@/components/datatables/detail_modal";
import http from "@/config/http";
import { reactive, computed } from "@vue/composition-api";
import { useQueryClient } from "@tanstack/vue-query";
import {
  useBranches,
  useCouriers,
  useAgenOptions,
  useDestinations,
} from "@/composables/master/useMaster";
import { useInternationalOrdersWithFilter } from "@/composables/transaction/useTransaction";
import { useProfile } from "@/composables/auth/useAuth";
import { fetchInternationalAdvanceSearch } from "@/queries/api/transaction";
import { keys } from "@/queries/keys";
export default {
  components: {
    layouts,
    datatable,
    zdropdown,
    zselect,
    zselectmultiple,
    zautocompleteinput,
    zloading,
    detailModal,
    notification,
  },
  setup() {
    const { data: branchesData } = useBranches();
    const { data: couriersData } = useCouriers();
    const { data: destinationsData } = useDestinations();
    const { data: agensData } = useAgenOptions({ type_user: null });
    const { data: serverProfile } = useProfile();

    const listParams = reactive({
      page: 1,
      limit: 100,
      pagination: true,
      search: "",
      start_date: "",
      end_date: "",
      courier: "",
      destination: "",
      status_order: "",
      manifest_date: "",
      agen: "",
      admin: "",
      payment_method: "",
      search_no_order: "",
      search_awb_no: "",
      search_recipient_name: "",
      filter_shipment_number: true,
      branch: undefined,
      branch_mutiple: undefined,
    });
    const listQuery = useInternationalOrdersWithFilter(
      computed(() => ({ ...listParams })),
    );

    /* Sumber list agen general — ambil filter list utama tanpa pagination. */
    const agenGeneralQuery = useInternationalOrdersWithFilter(
      computed(() => ({ pagination: false })),
    );

    const qc = useQueryClient();
    return {
      listParams,
      branchesData,
      couriersData,
      destinationsData,
      agensData,
      serverProfile,
      sbqListData: listQuery.data,
      sbqListIsLoading: listQuery.isLoading,
      sbqListRefetch: listQuery.refetch,
      sbqAgenGeneralData: agenGeneralQuery.data,
      qc,
    };
  },
  data() {
    return {
      /* Auth Token */
      columns: [
        {
          field: "shipment_number",
          label: "No Order",
        },
        {
          field: "awb_no",
          label: "No Resi",
        },
        {
          field: "status_order",
          label: "Status Order",
        },
        {
          field: "service_type",
          label: "Tipe Layanan",
        },
        {
          field: "recipient_name",
          label: "Nama Penerima",
        },
        {
          field: "sender_name",
          label: "Nama Pengirim",
        },
        {
          field: "courier",
          label: "Mitra Ekspedisi",
        },
        {
          field: "recipient_destination",
          label: "Negara Tujuan",
        },
        {
          field: "weight",
          label: "Berat",
        },
        {
          field: "agen",
          label: "Agen",
        },
        {
          field: "admin",
          label: "Admin",
        },
        {
          field: "branch",
          label: "Cabang",
        },
        {
          field: "manifest_date",
          label: "Tanggal Manifest",
        },
        {
          field: "createdAt",
          label: "Tanggal Order",
        },
      ],
      /* Filter — UI-local state untuk filter sebelum di-apply ke listParams. */
      viewOptions: "Card",
      filterDate: "",
      filter_courier: "",
      filter_destination: "",
      filter_status_order: "",
      filter_manifest_date: "",
      filter_agen: "",
      filter_admin: "",
      filter_payment_method: "",
      filter_branch: "",
      /* Toggle Dialog */
      scanBarcodeDialog: false,
      /* Form Value */
      /* Extra Data */
      code_barcode: "",
      successNotification: false,
      successMessage: "",
    };
  },
  computed: {
    profileData() {
      let profile = JSON.parse(
        window.localStorage.getItem("data-profile-jaskipin"),
      );
      if (profile) {
        return profile;
      } else {
        return null;
      }
    },
    page: {
      get() {
        return this.listParams.page;
      },
      set(v) {
        this.listParams.page = v;
      },
    },
    limit: {
      get() {
        return this.listParams.limit;
      },
      set(v) {
        this.listParams.limit = v;
      },
    },
    search: {
      get() {
        return this.listParams.search;
      },
      set(v) {
        this.listParams.search = v;
      },
    },
    start_date: {
      get() {
        return this.listParams.start_date;
      },
      set(v) {
        this.listParams.start_date = v;
      },
    },
    end_date: {
      get() {
        return this.listParams.end_date;
      },
      set(v) {
        this.listParams.end_date = v;
      },
    },
    search_no_order: {
      get() {
        return this.listParams.search_no_order || "";
      },
      set(v) {
        this.listParams.search_no_order = v;
      },
    },
    search_awb_no: {
      get() {
        return this.listParams.search_awb_no || "";
      },
      set(v) {
        this.listParams.search_awb_no = v;
      },
    },
    search_recipient_name: {
      get() {
        return this.listParams.search_recipient_name || "";
      },
      set(v) {
        this.listParams.search_recipient_name = v;
      },
    },
    data() {
      return this.sbqListData || { data: [], meta: null };
    },
    loading() {
      return this.sbqListIsLoading && !this.sbqListData;
    },
    courierOptions() {
      const raw = this.couriersData;
      const arr = Array.isArray(raw) ? raw : raw && raw.data ? raw.data : [];
      const out = [];
      arr.forEach((item) => {
        if (item.courier_type == "International") {
          out.push(item.courier_name);
        }
      });
      return out;
    },
    countryDestinationOptions() {
      const raw = this.destinationsData;
      const arr = Array.isArray(raw) ? raw : raw && raw.data ? raw.data : [];
      const out = arr.map((item) => item.country_name).filter(Boolean);
      out.sort();
      return out;
    },
    agenOptions() {
      const raw = this.agensData;
      const arr = Array.isArray(raw) ? raw : raw && raw.data ? raw.data : [];
      const out = [];
      arr.forEach((item) => {
        if (item.type_user && item.type_user.includes("Agen")) {
          out.push({ label: item.fullname, value: item.id });
        }
      });
      /* Tambahkan agen_general dari list filter (tanpa duplikat). */
      const rawAg = this.sbqAgenGeneralData;
      const arrAg = rawAg && rawAg.data ? rawAg.data : [];
      arrAg.forEach((item) => {
        if (item.agen_general && !out.find((o) => o === item.agen_general)) {
          out.push(item.agen_general);
        }
      });
      return out;
    },
    adminOptions() {
      const raw = this.agensData;
      const arr = Array.isArray(raw) ? raw : raw && raw.data ? raw.data : [];
      return arr.map((item) => ({ label: item.fullname, value: item.id }));
    },
    branchOptions() {
      const profile = this.serverProfile || this.profileData || {};
      if (profile.type_user == "Supervisor") {
        const tb = profile.type_branch || [];
        return Array.isArray(tb)
          ? tb.map((item) => ({ label: item.label, value: item.value }))
          : [];
      }
      const raw = this.branchesData;
      const arr = Array.isArray(raw) ? raw : raw && raw.data ? raw.data : [];
      return arr.map((item) => ({ label: item.city_name, value: item.id }));
    },
  },
  created() {
    /* Initiate Function — set profile filter & refetch.
     * Master data composables auto-fetch di setup. */
    this.getListData(this.page, this.limit);
  },
  methods: {
    /*
     * Apply filter UI-local ke listParams (termasuk profile-derived branch).
     */
    applyFilters() {
      if (this.filter_status_order === "Belum Ada Status") {
        this.filter_status_order = "";
      }
      this.listParams.courier = this.filter_courier;
      this.listParams.destination = this.filter_destination;
      this.listParams.status_order = this.filter_status_order;
      this.listParams.manifest_date = this.filter_manifest_date;
      this.listParams.agen = this.filter_agen;
      this.listParams.admin =
        this.filter_admin && this.filter_admin.value
          ? this.filter_admin.value
          : "";
      this.listParams.payment_method = this.filter_payment_method;
      this.listParams.search_no_order = (
        this.search_no_order || ""
      ).toUpperCase();
      this.listParams.search_awb_no = (this.search_awb_no || "").toUpperCase();

      const profile = this.serverProfile || this.profileData || {};
      if (profile.type_user == "Supervisor") {
        const tb = profile.type_branch || [];
        this.listParams.branch_mutiple = Array.isArray(tb)
          ? tb.map((it) => it.value)
          : [];
        this.listParams.branch = undefined;
      } else {
        if (
          profile.type_user !== "Super Admin" &&
          profile.type_user !== "Admin Pusat" &&
          profile.type_user !== "Gudang Pusat" &&
          profile.type_user !== "CS Pusat" &&
          profile.type_user !== "Finance" &&
          profile.type_user !== "Akunting"
        ) {
          this.listParams.branch =
            profile.branch && profile.branch._id
              ? profile.branch._id
              : undefined;
        } else {
          this.listParams.branch = undefined;
        }
        let branchMutiple = [];
        if (this.filter_branch && this.filter_branch.length > 0) {
          this.filter_branch.map((item) => {
            branchMutiple.push(item.value);
          });
        }
        this.listParams.branch_mutiple = branchMutiple;
      }
    },
    /*
     * Get Data Method — apply filter & refetch.
     */
    async getListData(page, limit) {
      if (typeof page === "number") this.listParams.page = page;
      if (typeof limit === "number") this.listParams.limit = limit;
      this.applyFilters();
      try {
        await this.sbqListRefetch();
      } catch (error) {
        console.log(error);
        if (
          error.message &&
          (error.message.includes("404") || error.message.includes("500"))
        ) {
          window.localStorage.removeItem("token-auth-jaskipin");
          window.localStorage.removeItem("data-profile-jaskipin");
          this.$router.push("/");
        }
      }
    },
    /*
     * Pagination Handler Function
     */
    pageNavHandler(type) {
      switch (type) {
        case "previous":
          this.page -= 1;
          this.getListData(this.page, this.limit);
          break;
        case "next":
          this.page += 1;
          this.getListData(this.page, this.limit);
          break;
      }
    },
    /*
     * Search Function
     */
    tableInputSearchHandler(event) {
      const value = event.target.value; // ambil value dari form input search

      if (value === "") {
        this.search = ""; // Mengkosongkan kembali state querynya
        this.getListData(this.page, this.limit);
      } else {
        this.search = value;
        this.getListData(1, this.limit); // Ketika Filter Search dilakukan tidak bisa jika diset pagenya diatas 1 kalau hasil recordnya gak lebih dari limit/10 record
      }
    },
    /* Apply filter by tombol "Terapkan" — reset ke page 1 lalu refetch. */
    applyFiltersClick() {
      this.page = 1;
      this.refreshData();
    },
    /* Helpers */
    resetData() {
      this.filterDate = "";
      this.start_date = "";
      this.end_date = "";
      this.filter_courier = "";
      this.filter_destination = "";
      this.filter_status_order = "";
      this.filter_manifest_date = "";
      this.filter_agen = "";
      this.filter_admin = "";
      this.filter_payment_method = "";
      this.filter_branch = "";
      this.$refs.filterCourierComponent.resetDataValue();
      this.$refs.filterDestinationComponent.resetDataValue();
      this.$refs.filterBranchComponent.resetDataValue();
      this.refreshData();
    },
    refreshData() {
      this.getListData(this.page, this.limit);
    },
    selectRangeDate() {
      let date = new Date();
      let firstDay;
      let lastDay;

      switch (this.filterDate) {
        case "Hari Ini":
          firstDay = date;
          lastDay = date;
          break;

        case "Bulan Ini":
          firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          break;

        case "Tahun Ini":
          firstDay = new Date(date.getFullYear(), 0, 1);
          lastDay = new Date(date.getFullYear(), 11, 31);
          break;

        case "7 Hari Terakhir":
          firstDay = new Date(date.setDate(date.getDate() - 7));
          lastDay = new Date();
          break;

        case "30 Hari Terakhir":
          firstDay = new Date(date.setDate(date.getDate() - 30));
          lastDay = new Date();
          break;

        default:
          firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          break;
      }

      this.start_date = this.convertDate(firstDay);
      this.end_date = this.convertDate(lastDay);
      /* Fetch dipicu oleh tombol Terapkan, tidak otomatis di sini. */
    },
    convertDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    formatPrice(number) {
      var rupiah = "";
      var angkarev = number
        .toString()
        .split("")
        .reverse()
        .join("");
      for (var i = 0; i < angkarev.length; i++)
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
      return rupiah
        .split("", rupiah.length - 1)
        .reverse()
        .join("");
    },
    formatDate(value) {
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };

      return new Date(value).toLocaleString("id-ID", options);
    },
    startScanBarcode() {
      this.scanBarcodeDialog = true;
      this.$refs.barcode_scanner.focus();
    },
    async onDetectBarcode() {
      if (this.code_barcode !== "") {
        let searchCode = this.code_barcode.toUpperCase();
        let shipment_number = null;

        const paramsShipmentNumber = {
          field: "shipment_number",
          search: searchCode,
        };
        const checkByShipmentNumber = await this.qc.fetchQuery({
          queryKey: [
            ...keys.international.all,
            "advance-search",
            paramsShipmentNumber,
          ],
          queryFn: () => fetchInternationalAdvanceSearch(paramsShipmentNumber),
          staleTime: 0,
        });
        if (checkByShipmentNumber && checkByShipmentNumber.data !== null) {
          shipment_number = checkByShipmentNumber.data.shipment_number;
        }

        const paramsAwbNo = { field: "awb_no", search: searchCode };
        const checkByAWBNo = await this.qc.fetchQuery({
          queryKey: [...keys.international.all, "advance-search", paramsAwbNo],
          queryFn: () => fetchInternationalAdvanceSearch(paramsAwbNo),
          staleTime: 0,
        });
        if (checkByAWBNo && checkByAWBNo.data !== null) {
          shipment_number = checkByAWBNo.data.shipment_number;
        }

        /* Update Transaction */
        if (shipment_number !== null) {
          try {
            let today = new Date();
            let data = {
              position_order: "Mitra",
              status_order: "Manifest",
              scanned_by: (this.serverProfile || this.profileData || {}).id,
              manifest_date: today,
            };

            let response = await http.put(
              `/api/v1/transaction/international-order/update-by-scan-barcode/${shipment_number}`,
              data,
              { headers: this.headers },
            );
            this.successMessage = response.data.message;
            this.successNotification = true;

            await this.qc.invalidateQueries({
              queryKey: keys.international.all,
            });
            this.refreshData();
            this.successNotification = false;

            if (response.data.status === 1) {
              this.code_barcode = "";
            }
          } catch (error) {
            console.log(error);
          }
        }
      }
    },
  },
};
</script>

<style scoped></style>
